import { BodyL } from '@salutejs/sdds-insol';
import NotFoundImage from '@/shared/assets/about_section/not-found.png';
import cls from './DataNotFound.module.scss';

export const DataNotFound = () => {
    return (
        <div className={cls.container}>
            <img src={NotFoundImage} alt="данные не найдены" />
            <BodyL className={cls.text} color="#333F48">
                Данные не найдены
            </BodyL>
        </div>
    );
};
